import {gql} from 'react-apollo';


const SAVE_PAGE_FILTERS = gql`
mutation savePageFilters($page: String!, $filters: String!) {
  savePageFilters(page: $page, filters: $filters) {
		success
		error
	}
}`;

export {SAVE_PAGE_FILTERS};


// WEBPACK FOOTER //
// ./src/components/dashboard/analytics/gql/mutation.js